import Reveal, { Eyebrow } from "./Reveal";

const CHAPTERS = [
  ["The message has not lost its power.", "The issue is that too many ministries have become digitally invisible."],
  ["People are scrolling for answers at midnight.", "They search for prayer before they ever enter a sanctuary. They watch sermons before they visit a church. They decide whether your ministry feels alive before they ever meet your pastor."],
  ["Visible without becoming worldly.", "Minister of Social Media™ helps churches become current without compromising truth, and relevant without diluting the Kingdom."],
  ["Your church does not need more noise.", "It needs a digital voice with purpose."],
];

export default function Manifesto() {
  return (
    <section id="manifesto" data-testid="manifesto-section" className="py-20 lg:py-32 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <Reveal><Eyebrow>The Manifesto</Eyebrow></Reveal>
        <div className="mt-10">
          {CHAPTERS.map(([head, body], i) => (
            <Reveal key={i} delay={i * 0.06}>
              <div className="grid grid-cols-12 gap-4 sm:gap-8 items-baseline border-t border-gold/15 py-10 lg:py-14 group">
                <span className="col-span-3 sm:col-span-2 font-display text-5xl sm:text-7xl text-gold/25 group-hover:text-gold/60 transition-colors duration-500">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <div className="col-span-9 sm:col-span-10">
                  <h3 className="font-display text-xl sm:text-2xl lg:text-3xl uppercase tracking-tight text-white">
                    {head}
                  </h3>
                  <p className="mt-3 text-sm sm:text-base text-slate-300 leading-relaxed max-w-2xl">{body}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
